import api from './client';
export const rolesApi = {
  list:               ()               => api.get('/roles'),
  permissionsCatalog: ()               => api.get('/roles/permissions-catalog'),
  show:               (id: number)     => api.get(`/roles/${id}`),
  create:             (data: any)      => api.post('/roles', data),
  update:             (id: number, data: any) => api.put(`/roles/${id}`, data),
  destroy:            (id: number)     => api.delete(`/roles/${id}`),
};
